const ModuleInfo = {
    ModuleId: 0,
    Name: "",
    Description: "",
    Subjectid: 0,
    Active: true,
    UserId: 0,
    CreatedDate: new Date(),
    PartnerId: 0,
    QuestionCount: 0,
    encPartnerID: ""
};